import { Injectable } from '@angular/core';
import { sendMessageSync } from '../../utils/electronHelpers';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {

  constructor() {

    this.subscribeDeviceStates();
   }

// TEMPORARY !
  async printPersonalDataLabel(firstName, lastName, address, matricule){
    let res = await sendMessageSync('printPersonalDataLabel', {firstName, lastName, address, matricule});
    console.devlog('printPersonalDataLabel:', res)
    return res;
  }
// TEMPORARY !
  isLabelPrinterAvailable = false;

  //currrent: availableDevices 

  async subscribeDeviceStates(){

  // TEMPORARY !
  // let msg = await this.sendMessage('getAllDeviceStates');
  const checkDymo = async () => {
    let msg = await sendMessageSync('getAllDeviceStates');
    //console.log("getAllDeviceStates?:", msg)
    try{
      this.isLabelPrinterAvailable = msg.toLowerCase() === 'true'
      console.devlog('isLabelPrinterAvailable:', this.isLabelPrinterAvailable)
    } catch(err){
      this.isLabelPrinterAvailable = false;
    }
  }

  //first, run once immediately.
  await checkDymo();

  //next, repeat in cycle.
  setInterval(async () => {
    try {
      await checkDymo();
    } catch(err) {
      console.deverror('Error in subscribeDeviceStates -> checkDymo:', err)
    }
  }, 5000);
}

}
